import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import SidebarItems from './SidebarItems'
import ProductsList from './ProductsList'
import ManagePortalList from './ManagePortalList'

const Sidebar = observer((props) => {
  return (
    <Fragment>
      <p className='menu-label'>
        Portal de Produtos
      </p>
      <ul className='menu-list'>
        <SidebarItems />
      </ul>

      <p className='menu-label'>
        Produtos
      </p>
      <ul className='menu-list'>
        <ProductsList />
      </ul>

      <p className="menu-label">
        Gerenciamento do Portal
      </p>
      <ul className="menu-list">
        <ManagePortalList />
      </ul>
    </Fragment>
  )
})

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/dashboard/Sidebar.js